export default __webpack_public_path__ + "static/media/QuiRe.8fefcdee.svg";